export interface SnackBarMessageOptionsModel {
  message: string;
  duration?: number;
  showSpinner?: boolean;
  showDuration?: boolean;
  showCloseButton?: boolean;
  closeButtonText?: string;
}
